<template>
    <div>
        <Modal v-model="isShowModal" title="订单评价" @on-cancel="hide('formValidate')" :mask-closable="false" width="950">
          <Divider orientation="left">用户评价</Divider>
          <Row :gutter="16">
            <Col span="8">

              <div>用户评分：<Rate v-model="userEvaluate.score" disabled/></div>
            </Col>
            <Col span="8">
              <div>评价内容：{{ userEvaluate.content }}</div>
            </Col>
          </Row>
          <Divider orientation="left">回收员评价</Divider>
          <Row :gutter="16">
            <Col span="8">
              <div>回收员评分：<Rate v-model="revoveryUserEvaluate.score" disabled/></div>
            </Col>
            <Col span="8">
              <div>评价内容：{{ revoveryUserEvaluate.content }}</div>
            </Col>
          </Row>
            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "order-evaluate",
        data() {
            return {
                isShowModal: false,
                loadingBtn: false,
                orderInfo: {},
                userEvaluate: {},
                revoveryUserEvaluate: {}
            }
        },
        methods: {
            // 显示模态框
            show(row) {
                this.isShowModal = true;
                this.getInfo(row)
            },
          // 查询订单详情
          getInfo(row) {
            this.$Spin.show();
            this.axios.post('/recoveryOrder/getInfo', {
              recoveryOrderId: row.recoveryOrderId
            }).then(res => {
              console.log(res);
              setTimeout(() => {
                this.$Spin.hide();
              }, 300);
              if (res.status == 200) {
                this.orderInfo = res.data;
                if (res.data.evaluateList && res.data.evaluateList.length > 0) {
                  this.orderInfo.evaluateList.forEach(item => {
                    if (item.type === 1) {
                      this.userEvaluate = item
                    }
                    if (item.type === 2) {
                      this.revoveryUserEvaluate = item
                    }
                  })
                }
              }
              if (res.status == 500) {
                this.$Notice.error({
                  title: '服务器内部错误',
                  desc: '查看订单详情接口报错',
                  duration: 0
                });
              }
            })
          },
            // 关闭模态框
            hide(name) {
                this.isShowModal = false;
            }
        }
    }
</script>

<style scoped lang="less">

</style>